import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import "./AppHeader.css";
import walletIcon from "../assets/icons/wallet_figma1.svg";  // your wallet icon
import backIcon from "../assets/icons/back.png";      // your saved back icon
import { AppContext } from "../context/AppContext";

export default function AppHeader({ title = "", onBack, onWalletClick , walletBalance = 0 }) {
  const navigate = useNavigate();
  const { isInactive } = useContext(AppContext);

  const handleBack = () => (onBack ? onBack() : navigate(-1));

  return (
    <header className="app-header">
      {/* LEFT: back icon */}
      <button className="back-bttn" onClick={handleBack} aria-label="Back">
        <img src={backIcon} alt="Back" className="back-icon" />
      </button>

      {/* TITLE (left-aligned after back btn) */}
      <h1 className="headeer-title">{title}</h1>

      {/* RIGHT: wallet */}
      <div className="wallet-section">
      <button
        className="wallet-btn"
        onClick={onWalletClick}
        aria-label="Wallet"
      >
        <img src={walletIcon} alt="Wallet" className="wallet-icon" />
         
      </button>
      <span className="wallet-count">
        {isInactive ? `🪙 ${walletBalance}` : `₹ ${walletBalance}`}
      </span>
      </div>
    </header>
  );
}
